export default "__VITE_ASSET__B565sort__"